import moment from 'moment';

export function toDate(str) {
    if (!str) {
        return null;
    }

    return moment(str).toDate();
}

export function getFullName(name) {
    if (typeof name === 'string') {
        return name;
    } else {
        let fullname = '';

        if (name.firstName) fullname = `${name.firstName} `;
        if (name.middleName) fullname += `${name.middleName} `;
        if (name.lastName) fullname += `${name.lastName} `;
        if (name.nameSuffix) fullname += `${name.nameSuffix}`;

        return fullname.trim();
    }
}
